import { axiosInstance } from './common';

export const createShare = (dataCaptureId, granteeId, granteeType, permission) =>
  axiosInstance.post('/share', { dataCaptureId, granteeId, granteeType, permission }).then((r) => r.data);

export const revokeShare = (shareId) =>
  axiosInstance.delete(`/share/${shareId}`).then((r) => r.data);

export const getSharesForRecording = (dataCaptureId) =>
  axiosInstance.get(`/share/recording/${dataCaptureId}`).then((r) => r.data);

export const getSharedWithMe = () =>
  axiosInstance.get('/share/shared-with-me').then((r) => r.data);

export const updatePermission = (shareId, permission) =>
  axiosInstance.put(`/share/${shareId}`, { permission }).then((r) => r.data);

export const searchUsers = (query) =>
  axiosInstance.get('/user/search', { params: { q: query } }).then((r) => r.data);

export const getSharedDataCaptures = () =>
  axiosInstance.get('/datacapture/shared').then((r) => r.data);

let sharedDataCapturesCache = null;

export const getCachedSharedDataCaptures = async () => {
  if (sharedDataCapturesCache) {
    return sharedDataCapturesCache;
  }
  const data = await getSharedDataCaptures();
  sharedDataCapturesCache = data;
  return data;
};

export const invalidateSharedDataCapturesCache = () => {
  sharedDataCapturesCache = null;
};
